import { requestAberto } from "@/lib/api"
import { z } from "zod"
import { type Descadastro, DestinatarioSchema } from "./schema"

const BASE = "/condo-loan-async/open/contacts/opt-out"

export const fetchDestinatario = async (token: string) =>
    requestAberto(`${BASE}?t=${encodeURIComponent(token)}`, DestinatarioSchema)

// Campo vazio não vai: o serviço lê a ausência como "não informou", e um "" chegaria como e-mail.
export const descadastrar = async (token: string, { reason, text, hr_email }: Descadastro) =>
    requestAberto(BASE, z.unknown(), {
        method: "POST",
        body: JSON.stringify({
            t: token,
            reason,
            ...(reason === "OTHER" && text ? { text } : {}),
            ...(hr_email ? { hr_email } : {}),
        }),
    })
